document.addEventListener('DOMContentLoaded', function() {
    // Use event delegation to handle all expand buttons
    document.addEventListener('click', function(e) {
        if (e.target.closest('.expand-btn')) {
            const button = e.target.closest('.expand-btn');
            const section = button.closest('.img-content-col-pad');
            const container = section.querySelector('.expandable-content');
            const btnText = button.querySelector('.btn-text');

            container.classList.toggle('expanded');
            button.classList.toggle('active');

            if (container.classList.contains('expanded')) {
                btnText.textContent = 'Collapse';
            } else {
                btnText.textContent = 'Expand';

                // Scroll to top of this specific section
                section.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        }
    });
});